import { render, staticRenderFns } from "./ExpensesTypeDelete.vue?vue&type=template&id=0f22b43c&"
import script from "./ExpensesTypeDelete.vue?vue&type=script&lang=js&"
export * from "./ExpensesTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports